/* global r3_category */
/* global r3_brand */
/* global rr_flush_onload */
/* global r3 */
/* global r3_common */
import React, { Component } from 'react';
import Spinner from '../../Spinner/Spinner';

let loadingRR = false;
const ID_PREFIX = 'store-app-recommendations';
const clearContext = () => {
  if (window.R3_COMMON) {
    window.R3_COMMON.destroy();
  }
  window.R3_COMMON = undefined;

  if (window.R3_CATEGORY) {
    window.R3_CATEGORY.destroy();
  }
  window.R3_CATEGORY = undefined;

  if (window.R3_SEARCH) {
    window.R3_SEARCH.destroy();
  }
  window.R3_SEARCH = undefined;

  if (window.R3_ITEM) {
    window.R3_ITEM.destroy();
  }
  window.R3_ITEM = undefined;

  if (window.R3_ADDTOCART) {
    window.R3_ADDTOCART.destroy();
  }
  window.R3_ADDTOCART = undefined;

  if (window.R3_CART) {
    window.R3_CART.destroy();
  }
  window.R3_CART = undefined;

  if (window.R3_PURCHASED) {
    window.R3_PURCHASED.destroy();
  }
  window.R3_PURCHASED = undefined;

  if (window.R3_BRAND) {
    window.R3_BRAND.destroy();
  }
  window.R3_BRAND = undefined;
};

class Recommendations extends Component {
  constructor(props) {
    super(props);
    this.carouselRef = React.createRef();
    this.state = {
      inProgress: false,
      id: `${ID_PREFIX}-${Math.floor(Math.random() * 1001)}`,
      richRelevanceUnavailable: false
    };
  }

  loadRecommendations() {
    const id = this.state.id;
    const intervalId = window.setInterval(() => {
      if (loadingRR) {
        return;
      }

      loadingRR = true;
      window.RR.jsonCallback = () => {
        const { placements } = window.RR.data.JSON;
        if (placements.length > 0) {
          const settings = (window.ow.state.carousel.settings[id] = {
            SKUs: placements[0].items.map(item => item.partNumber).join(','),
            targetDivId: id,
            templateName: 'product-grid-view',
            espotTitle: placements[0].message
          });

          this.showProductCarousel(settings);

          loadingRR = false;
          window.clearInterval(intervalId);
        }
      };

      const {
        recommendationsType,
        recommendationsValue
      } = this.props.contentBlock;

      clearContext();

      window.R3_COMMON = new r3_common();
      window.R3_COMMON.setApiKey('ddce772e3b196319');
      window.R3_COMMON.setBaseUrl(
        window.location.protocol + '//integration.richrelevance.com/rrserver/'
      );
      window.R3_COMMON.setClickthruServer(
        window.location.protocol + '//' + window.location.host
      );

      if (recommendationsType === 'category') {
        window.R3_COMMON.addPlacementType(
          `${recommendationsType}_page.LeafCat_Recommends_ESpot_Bottom`
        );
        window.R3_CATEGORY = new r3_category();
        window.R3_CATEGORY.setId(recommendationsValue);
      }

      if (recommendationsType === 'brand') {
        window.R3_COMMON.addPlacementType(
          `${recommendationsType}_page.cms-brand-recommendations`
        );
        window.R3_COMMON.setPageBrand(recommendationsValue);
        window.R3_BRAND = new r3_brand();
      }

      rr_flush_onload();

      r3();
    }, 500);
  }

  checkForRichRelevance(delay, repetitions) {
    const self = this;
    let x = 0;
    let intervalID = window.setInterval(function() {
      if (typeof window.RR !== 'undefined') {
        window.clearInterval(intervalID);
        self.loadRecommendations();
      }

      if (++x === repetitions) {
        window.clearInterval(intervalID);
        self.setState({ richRelevanceUnavailable: true });
      }
    }, delay);
  }

  componentDidMount() {
    if (
      !(
        process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'test'
      )
    ) {
      return;
    }

    if (!(window && window.RR)) {
      this.checkForRichRelevance(1000, 5);
    } else {
      this.loadRecommendations();
    }
  }

  componentDidUpdate(prevProps) {
    if (
      !(
        process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'test'
      )
    ) {
      return;
    }
    if (
      prevProps.contentBlock.recommendationsType !==
        this.props.contentBlock.recommendationsType ||
      prevProps.contentBlock.recommendationsValue !==
        this.props.contentBlock.recommendationsValue
    ) {
      this.carouselRef.current.innerHTML = '';
      this.loadRecommendations();
    }
  }

  rrProductSkusLoaded = id => () => {};

  showProductCarousel(settings) {
    const productCarouselControl = window.ow.controls.productCarouselControl;

    this.setState({
      inProgress: true
    });
    const timeoutId = window.setTimeout(() => {
      window.clearTimeout(timeoutId);
      if (this.state.inProgress) {
        this.setState({
          inProgress: false
        });
      }
    }, 1000);

    productCarouselControl.showProductCarousel(settings);
  }

  render() {
    const {
      recommendationsType,
      recommendationsValue
    } = this.props.contentBlock;

    if (
      !(
        process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'test'
      )
    ) {
      return (
        <div className="text-center">
          <h3>Recommendations</h3>
          <p>Type: {recommendationsType}</p>
          <p>Value: {recommendationsValue}</p>
        </div>
      );
    }

    if (this.state.richRelevanceUnavailable) {
      // Rich Relevance is unavailable so display nothing
      return null;
    }

    return (
      <React.Fragment>
        {this.state.inProgress && <Spinner />}
        <div id={this.state.id} ref={this.carouselRef} />
      </React.Fragment>
    );
  }
}

export default Recommendations;



// WEBPACK FOOTER //
// ./src/components/content-blocks/Recommendations/Recommendations.js